/**
 * @ngdoc directive
 * @name cbl.insuranceloanpmi.mf.directive:creasDatiAffidamento
 * @restrict E
 * @description Componente che gestisce il primo sotto-step "Dati Affidamento"
 *              dello step "Richiesta fido"
 * @param {Object}
 *            step - Rappresenta la configurazione da assegnare a questo
 *            sotto-step
 */
(function() {
  'use strict';
  var CreasDatiAffidamentoCtrl = function(
    $http,
    $scope,
    $state,
    $stateParams,
    $window,
    $q,
    $httpParamSerializer,
    CONSTANTS,
    labelSrvc,
    messaggiFctr,
    dettPraticaSrvc
  ) {
    this.$http = $http;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$window = $window;
    this.messaggiFctr = messaggiFctr;
    this.dettPraticaSrvc = dettPraticaSrvc;
    this.CONSTANTS = CONSTANTS;
    $scope.msg = labelSrvc.getLabel;

    this.datiCliente = this.dettPraticaSrvc.getDatiCliente();
    this.firmatari = this.dettPraticaSrvc.firmatariCliente;
    this.fasceAffidamento = [];
    
    this.spinner = this.dettPraticaSrvc.spinner;
    
    this.subSpinner = {
      firmatari: false,
      fasce: false
    };

    var self = this;

    // Configuro l'abilitazione dei pulsanti di scorrimento tra gli step
    dettPraticaSrvc.isCancelEnabled = function() {
      return true;
    };

    dettPraticaSrvc.isSaveEnabled = function() {
      return (
        (self.dettPraticaSrvc.firmatario !== null || self.dettPraticaSrvc.datiPratica.idPraticaRinnovata) &&
        self.dettPraticaSrvc.fasciaAffidamento !== null
      );
    };

    dettPraticaSrvc.isNextEnabled = function() {
      return (
    	(self.dettPraticaSrvc.firmatario !== null || self.dettPraticaSrvc.datiPratica.idPraticaRinnovata) &&
        self.dettPraticaSrvc.fasciaAffidamento !== null
      );
    };

    /**
	 * @ngdoc method
	 * @name promiseFasceAffidamento
	 * @methodOf cbl.insuranceloanpmi.mf.directive:creasDatiAffidamento
	 * @description Effettua una chiamata http per recuperare le fasce di
	 *              affidamento abilitate
	 * @return {Promise} - Ritorna una promise contenente le fasce di
	 *         affidamento abilitate
	 */
    this.promiseFasceAffidamento = function() {
      return this.$http({
        method: 'GET',
        url: CONSTANTS.REST_ROOT + CONSTANTS.REST.FASCEAFFIDAMENTO
      });
    };

    /**
	 * @ngdoc method
	 * @name recuperaFasceAffidamento
	 * @methodOf cbl.insuranceloanpmi.mf.directive:creasDatiAffidamento
	 * @description Esegue il recupero della fasce di affidamento selezionabili
	 */
    this.recuperaFasceAffidamento = function() {
      self.subSpinner.fasce = true;
    	
      $q
        .all({
          fasceAffidamento: self.promiseFasceAffidamento()
        })
        .then(
          function(response) {
            if (self.messaggiFctr.processaResponse(response.fasceAffidamento)) {
              self.fasceAffidamento = [];
              return;
            }
            self.fasceAffidamento = response.fasceAffidamento.data.result;
            self.impostaFasciaSelezionata();
          },
          function(reason) {
            self.messaggiFctr.processaResponse(reason.fasceAffidamento);
            self.fasceAffidamento = [];
          }
        )
        .finally(function() {
        	self.subSpinner.fasce = false;
        });
    };

    /**
	 * @ngdoc method
	 * @name impostaFasciaSelezionata
	 * @methodOf cbl.insuranceloanpmi.mf.directive:creasDatiAffidamento
	 * @description Visualizza come selezionata nella tendina la fascia
	 *              assegnata alla pratica
	 */
    this.impostaFasciaSelezionata = function() {
      angular.forEach(self.fasceAffidamento, function(value) {
        if (
          self.dettPraticaSrvc.fasciaAffidamento &&
          self.dettPraticaSrvc.fasciaAffidamento.idFasciaFidoPMI ===
            value.idFasciaFidoPMI
        ) {
          self.dettPraticaSrvc.fasciaAffidamento = value;
        } else if (
          self.dettPraticaSrvc.datiPratica.fidoNonOperativo &&
          self.dettPraticaSrvc.datiPratica.fidoNonOperativo.fasciaFido &&
          self.dettPraticaSrvc.datiPratica.fidoNonOperativo.fasciaFido
            .idFasciaFidoPMI === value.idFasciaFidoPMI
        ) {
          self.dettPraticaSrvc.fasciaAffidamento = value;
        }
      });
    };

    /**
	 * @ngdoc method
	 * @name getFirmatariCliente
	 * @methodOf cbl.insuranceloanpmi.mf.directive:creasDatiAffidamento
	 * @description Recupera i firmatari del cliente con una struttura standard,
	 *              valorizzata a seconda del tipo di dato ottenuto (DB Banca o
	 *              Cerved)
	 */
    this.getFirmatariCliente = function() {
      self.subSpinner.firmatari = true;
    	
      self.firmatari = [];
      $q
        .all({
          firmatariCliente: self.dettPraticaSrvc.promiseFirmatariCliente()
        })
        .then(
          function(response) {
            if (
              self.messaggiFctr.processaResponse(response.firmatariCliente) !==
              false
            ) {
              return;
            }
            // imposta l'array firmatari locale e del service
            self.firmatari = response.firmatariCliente.data.result;
            self.dettPraticaSrvc.firmatariCliente = response.firmatariCliente.data.result;
            self.impostaFirmatarioSelezionato();
          },
          function(reason) {
            self.messaggiFctr.processaResponse(reason.firmatariCliente);
            self.firmatariCliente = [];
          }
        )
        .finally(
        	function() {
        		self.subSpinner.firmatari = false;
        	}
        );
      return;
    };

    /**
	 * @ngdoc method
	 * @name impostaFirmatarioSelezionato
	 * @methodOf cbl.insuranceloanpmi.mf.directive:creasDatiAffidamento
	 * @description Visualizza come selezionato il firmatario scelto per la
	 *              pratica
	 */
    this.impostaFirmatarioSelezionato = function() {
      angular.forEach(self.firmatari, function(value) {
        if (
          self.dettPraticaSrvc.firmatario &&
          self.dettPraticaSrvc.firmatario.ndg === value.ndg
        ) {
          self.dettPraticaSrvc.firmatario = value;
        } else if (
          self.dettPraticaSrvc.datiPratica.intestatario &&
          self.dettPraticaSrvc.datiPratica.intestatario.relazioniAnagrafiche &&
          self.dettPraticaSrvc.datiPratica.intestatario.relazioniAnagrafiche[0]
            .ndg === value.ndg
        ) {
          self.dettPraticaSrvc.firmatario = value;
        }
      });
    };

    /**
	 * @ngdoc method
	 * @name setFirmatarioPratica
	 * @methodOf cbl.insuranceloanpmi.mf.directive:creasDatiAffidamento
	 * @description Esegue il salvataggio del firmatario per la pratica in
	 *              lavorazione
	 * @param {Object}
	 *            firmatario - Il firmatario da assegnare alla pratica
	 */
    this.setFirmatarioPratica = function(firmatario) {
      var firmatarioObject = {
        formaCostitutiva: firmatario.formaCostitutiva,
        intestazione: firmatario.intestazione,
        ndg: firmatario.ndg,
        idAnagrafica: firmatario.idAnagrafica
      };
      // this.dettPraticaSrvc.firmatario = firmatarioObject;
      this.dettPraticaSrvc.datiPratica.intestatario.relazioniAnagrafiche = [
        firmatarioObject
      ];
    };
    this.recuperaFasceAffidamento();
    this.getFirmatariCliente();
  };

  CreasDatiAffidamentoCtrl.$inject = [
    '$http',
    '$scope',
    '$state',
    '$stateParams',
    '$window',
    '$q',
    '$httpParamSerializer',
    'CONSTANTS',
    'LabelSrvc',
    'CreasMessaggiFctr',
    'CreasDettaglioPraticaSrvc'
  ];

  var TemplateUrl = function(CONSTANTS) {
    return (
      CONSTANTS.BASE_ROOT +
      CONSTANTS.COMPONENTS_PATH +
      'creasDettaglioPratica/creasRichiestaFido/creasDatiAffidamento/creasDatiAffidamento.html'
    );
  };

  TemplateUrl.$inject = ['CONSTANTS'];

  var CreasDatiAffidamentoComponent = {
    bindings: {
      step: '='
    },
    controller: CreasDatiAffidamentoCtrl,
    controllerAs: 'creasDatiAffidamentoCtrl',
    templateUrl: TemplateUrl
  };

  angular
    .module('cbl.insuranceloanpmi.mf')
    .component('creasDatiAffidamento', CreasDatiAffidamentoComponent);
})();



//////////////////
// WEBPACK FOOTER
// ./app/components/creasDettaglioPratica/creasRichiestaFido/creasDatiAffidamento/creasDatiAffidamento.cmpt.js
// module id = 19
// module chunks = 0 1